import script from "./TokenTxTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenTxTable.vue?vue&type=script&setup=true&lang=ts"

import "./TokenTxTable.vue?vue&type=style&index=0&id=41f9709a&lang=scss"

const __exports__ = script;

export default __exports__